import React, {Component} from 'react';
import Header from "./header";
import "./homePage.css";
import Slider from "react-slick";
import Footer from "./footer";
import { Responsive, Container, Grid, Image } from 'semantic-ui-react';
import HistoryItem from "./historyitem";
import FacebookProvider, { Page } from 'react-facebook';
import YouTube from 'react-youtube';
class WhatIsRotary extends Component {

  componentWillMount(){


  }

  render() {
    const opts = {
      width:"1040",
      height:"584",
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1
      }
    };

    return (
      <div className="Homepage">

        <Header page="aboutus"/>

          <div className="homeContentWhite">
            <a id="overview">
              <Container>
                <div className="AboutUsImage">
                <YouTube
                  videoId="jLUpWV8z3ws"
                  opts={opts}
                  onReady={this._onReady}
                />
                </div>
                <div className="AboutUsTitle">

                </div>
                <div className="AboutUsText left">
                Rotary is a global network of 1.2 million neighbors, friends, leaders, and problem-solvers who see a world where people unite and take action to create lasting change – across the globe, in our communities, and in ourselves.<br/>
                <br/>
                Solving real problems takes real commitment and vision. For more than 110 years, Rotary's people of action have used their passion, energy, and intelligence to take action on sustainable projects. From literacy and peace to water and health, we are always working to better our world, and we stay committed to the end.
                <br/>
                <br/>
                <br/>
                What we do
                <br/>
                <br/>
                <br/>
                Rotary members believe that we have a shared responsibility to take action on our world’s most persistent issues. Our 35,000+ clubs work together to:
                <br/>
                <br/>
                <ul>
                <li>Promote peace</li>
                <li>Fight disease</li>
                <li>Provide clean water, sanitation, and hygiene</li>
                <li>Save mothers and children</li>
                <li>Support education</li>
                <li>Grow local economies</li>
                </ul>
                </div>
              </Container>
            </a>
          </div>

        <Footer/>
      </div>
    );
  }
}

export default WhatIsRotary;
